import { Switch, withStyles } from '@material-ui/core';
import { white } from '../../../theme';

const MainSwitch = withStyles((theme) => ({
  root: {
    width: (props) => {
      const sizeByProps = {
        small: 40,
        medium: 52,
      };
      return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : sizeByProps.small;
    },
    height: (props) => {
      const sizeByProps = {
        small: 22,
        medium: 30,
      };
      return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : sizeByProps.small;
    },
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 3,
      marginLeft: (props) => {
        const sizeByProps = {
          small: 3,
          medium: 4,
        };
        return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : sizeByProps.small;
      },
      transitionDuration: '300ms',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.gray.efesGray,
      },
      '&.Mui-checked': {
        transform: (props) => {
          const sizeByProps = {
            small: 'translateX(18px)',
            medium: 'translateX(20px)',
          };
          return props.size && sizeByProps[props.size]
            ? sizeByProps[props.size]
            : sizeByProps.small;
        },
        color: theme.palette.white.main,
        '& + .MuiSwitch-track': {
          backgroundColor: (props) => {
            const bgColor = {
              primary: theme.palette.primary.main,
              secondary: theme.palette.secondary.main,
            };
            return props.color ? bgColor[props.color] : theme.palette.primary.main;
          },
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: `6px solid ${white}`,
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.gray.efesLight,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: (props) => {
        const sizeByProps = {
          small: 16,
          medium: 24,
        };
        return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : sizeByProps.small;
      },
      height: (props) => {
        const sizeByProps = {
          small: 16,
          medium: 24,
        };
        return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : sizeByProps.small;
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 15,
      backgroundColor: theme.palette.gray.efesGray,
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  },
}))(Switch);

export default MainSwitch;
